export default class Banner {
    constructor() {
        this.banner = document.querySelector(".js-banner");
        this.closeBtn = document.querySelector(".js-banner-close");

        // バナーが出ない構成でも後続モジュールを巻き添えにしないためのガード
        if (!this.banner || !this.closeBtn) return;

        this.init();
    }

    init() {
        this.closeBanner();
    }

    // SPは閉じるボタン自体がdisplay:noneのため発火しない(表示維持は_banner.scss側で担保)
    closeBanner() {
        this.closeBtn.addEventListener("click", () => {
            this.banner.setAttribute("data-state", "inactive");
        });
    }
}
